import AuditTrailFiltersComponent from "../AuditTrailFiltersComponent";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import AuditTrailSummaryComponent from "../AuditTrailSummaryComponent";
import { useAuditTrailTableDataSummaryAPI } from "@/app/hooks/api_hooks/Inventory/AuditTrail/useAuditTrailTableDataSummaryAPI";
import { useEffect, useState } from "react";
import { IAuditTrailDataSummaryParamsBody } from "@/api_framework/api_modals/Inventory";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useLoader } from "@/app/hooks/useLoader";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import NoRecordFoundComponent from "@/app/components/ui/NoRecordFound";
import TableSkeletonComponent from "@/app/components/ui/LoaderComponent";
import { useUtils } from "@/app/hooks/useUtils";

const AuditTrailDetailComponent = () => {
  const { getRouteKey } = useRouter();
  const [tableDataSummary, setTableDataSummary] = useState<IAuditTrailDataSummaryParamsBody>();
  const { execute: fetchTableDataSummary } = useAuditTrailTableDataSummaryAPI();
  const routeIdConfig = getRouteKey("INVENTORY", "id");
  const { routeState } = useRouteInfo(routeIdConfig);
  const { auditTrailTableSummaryData } = routeState.state as IInventoryState;
  const isVaccinationLoader = useLoader("isvaccinationTableLoading");
  const { NO_PWL_RESULTS } = useImageConstants();
  const { veticDateFormat } = useUtils();

  useEffect(() => {
    if (tableDataSummary?.clinic_ids?.length > 0) {
      const filterBody = {
        ...tableDataSummary,
      } as IAuditTrailDataSummaryParamsBody;
      fetchTableDataSummary(filterBody);
    }
  }, [tableDataSummary]);

  return (
    <div>
      <AuditTrailFiltersComponent setTableDataSummary={setTableDataSummary} />
      {isVaccinationLoader ? (
        <TableSkeletonComponent columnLength={5} bodyLength={6} />
      ) : auditTrailTableSummaryData?.table_data?.length > 0 ? (
        <div className="px-0 sm:px-2 lg:px-2 mt-3">
          <div className="mt-1 flow-root">
            <div
              className="outer-container relative rounded-xl bg-[#F9FAFB]"
              style={{
                // boxShadow: "0px 4px 4px 0px rgba(61, 70, 112, 0.08)",
                borderRadius: "12px",
              }}
            >
              <div className="scroll-inner !h-auto max-h-[550px] overflow-auto">
                <div className="bg-white rounded-lg">
                  <table className="w-full border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
                    <thead className="bg-[#F5F5F5] text-[#1F1F23] font-normal">
                      <tr>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          S.NO
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          Date & Time
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          Action Type
                        </th>
                        {tableDataSummary?.clinic_ids?.length > 1 && (
                          <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                            Clinic
                          </th>
                        )}
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          Lot & Expiry
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          In Quantity
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          Out Quantity
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          On-Hand Quantity
                        </th>
                        <th className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23]">
                          Action Details
                        </th>
                      </tr>
                    </thead>
                    <tbody className="overflow-hidden rounded-xl w-full">
                      {auditTrailTableSummaryData?.table_data?.map((tableData, id) => {
                        const isFirst = id === 0;
                        const isLast = id === auditTrailTableSummaryData.table_data.length - 1;
                        const isSingle = auditTrailTableSummaryData.table_data.length === 1;

                        return (
                          <tr
                            key={id}
                            className={`bg-white transition ${isSingle ? "rounded-xl" : ""} ${
                              isFirst && !isSingle ? "rounded-t-xl" : ""
                            } ${isLast && !isSingle ? "rounded-b-xl" : ""}`}
                          >
                            <td
                              className={`px-3 py-3 whitespace-nowrap text-xs ${
                                isSingle ? "rounded-tl-2xl rounded-bl-2xl" : ""
                              } ${isFirst && !isSingle ? "rounded-tl-2xl" : ""} ${
                                isLast && !isSingle ? "rounded-bl-2xl" : ""
                              }`}
                            >
                              {id + 1}
                            </td>
                            {tableData?.created_at && Number(tableData.created_at) > 0 ? (
                              <td className="px-3 py-3 whitespace-nowrap text-xs text-[#6C727F]">
                                <div className="flex flex-col gap-1">
                                  <p className="text-xs text-[#1F1F23]">
                                    {new Date(
                                      typeof tableData.created_at === "string"
                                        ? Date.parse(tableData.created_at)
                                        : Number(tableData.created_at) < 9999999999
                                          ? Number(tableData.created_at) * 1000
                                          : Number(tableData.created_at),
                                    ).toLocaleDateString("en-IN", {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    })}
                                  </p>
                                  <p className="text-xs text-[#6C727F]">
                                    {new Date(
                                      typeof tableData.created_at === "string"
                                        ? Date.parse(tableData.created_at)
                                        : Number(tableData.created_at) < 9999999999
                                          ? Number(tableData.created_at) * 1000
                                          : Number(tableData.created_at),
                                    ).toLocaleTimeString("en-IN", {
                                      hour: "numeric",
                                      minute: "2-digit",
                                      hour12: true,
                                    })}
                                  </p>
                                </div>
                              </td>
                            ) : (
                              <td className="px-3 py-3 whitespace-nowrap text-xs font-normal text-[#9CA3AF]">N/A</td>
                            )}
                            <td className="px-3 py-3 whitespace-nowrap text-xs font-normal">
                              <span className="inline-flex min-w-[120px] items-center justify-center rounded-full bg-[#F3F4F6] border border-[#e8e8ea] px-3 py-2 text-xs text-black">
                                {tableData?.action_type || "NA"}
                              </span>
                            </td>
                            {tableDataSummary?.clinic_ids?.length > 1 && (
                              <td className="px-3 py-3 whitespace-nowrap text-xs font-normal">
                                {tableData?.clinic_name || "NA"}
                              </td>
                            )}
                            <td className="px-3 py-3 whitespace-nowrap text-xs font-normal text-[#6C727F]">
                              <div className="flex flex-col gap-1">
                                <p className="text-xs font-normal text-[#1F1F23]">{tableData?.lot_details?.lot_number || "NA"}</p>
                                <p className="text-[10px] font-medium text-[#6C727F]">
                                  {veticDateFormat(tableData?.lot_details?.expiry_date)}
                                </p>
                              </div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-xs font-semibold text-green-700">
                              <div className="flex gap-1 items-center">
                                <p>{tableData?.quantity_in === 0 ? "-" : tableData?.quantity_in}</p>
                                {tableData?.quantity_in !== 0 && <FaArrowUp size={10} />}
                              </div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-xs font-semibold text-red-500">
                              <div className="flex gap-1 items-center">
                                <p>{tableData?.quantity_out === 0 ? "-" : tableData?.quantity_out}</p>
                                {tableData?.quantity_out !== 0 && <FaArrowDown size={10} />}
                              </div>
                            </td>
                            <td className="px-3 py-3 whitespace-nowrap text-xs font-semibold text-[#1F1F23]">
                              {tableData?.updated_in_hand_quantity}
                            </td>
                            <td
                              className={`px-3 py-3 text-xs font-normal  ${
                                isSingle ? "rounded-tr-2xl rounded-br-2xl" : ""
                              } ${isFirst && !isSingle ? "rounded-tr-2xl" : ""} ${
                                isLast && !isSingle ? "rounded-br-2xl" : ""
                              }`}
                            >
                              <p className="flex items-center gap-1 text-xs font-medium text-[#0B6EFF] underline underline-offset-2 cursor-pointer">
                                {tableData?.action_details?.action_id}
                              </p>
                              <div className="mt-1 flex flex-col gap-1">
                                {tableData?.action_details?.items?.map((actionDetail, index) => {
                                  const isLinkDisabled = !actionDetail?.item_id;
                                  return isLinkDisabled ? (
                                    <span
                                      key={index}
                                      className="text-xs cursor-default"
                                    >
                                      {actionDetail?.display_value}
                                    </span>
                                  ) : (
                                    <a
                                      key={index}
                                      href={actionDetail?.item_id}
                                      className="text-xs text-[#0B6EFF] underline underline-offset-2 cursor-pointer"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {actionDetail?.display_value}
                                    </a>
                                  );
                                })}
                              </div>
                              <p className="mt-2 text-xs text-[#6C727F]">
                                {tableData?.action_details?.action_by}
                              </p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div>
            <AuditTrailSummaryComponent />
          </div>
        </div>
      ) : (
        <NoRecordFoundComponent imageURL={NO_PWL_RESULTS} message="No Audit Trail Data Found" />
      )}
    </div>
  );
};

export default AuditTrailDetailComponent;
